import React, { useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import DelayRender from './DelayRender';
import './Roulette.css';
import useBank from './useBank';
import { formatMoney } from '../utils/FormatUtils';
import { ROULETTE_DENOMINATIONS } from '../utils/GameConstants';

const Roulette = () => {
  const navigate = useNavigate();
  const { user, depositMoney, withdrawMoney, refreshUser } = useBank();
  const [currentBet, setCurrentBet] = useState(0);
  const [wager, setWager] = useState(1);
  const [bet, setBet] = useState([]);
  const [spinResult, setSpinResult] = useState(null);
  const [winningMessage, setWinningMessage] = useState('');
  const [isSpinning, setIsSpinning] = useState(false);
  const numRed = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];

  const resetGame = () => {
    setCurrentBet(0);
    setWager(1);
    setBet([]);
    setSpinResult(null);
    setWinningMessage('');
  };

  const spin = async () => {
    if (currentBet === 0 || isSpinning) {
      return;
    }

    setIsSpinning(true);
    setWinningMessage('');
    setSpinResult(null);

    if (user.money < currentBet) {
      setWinningMessage('Insufficient funds to place this bet.');
      setIsSpinning(false);
      return;
    }

    await depositMoney(currentBet);

    const newRandomNumber = Math.floor(Math.random() * 37);

    setTimeout(() => {
      const color = newRandomNumber === 0 ? 'green' : numRed.includes(newRandomNumber) ? 'red' : 'black';
      const result = { number: newRandomNumber, color };
      setSpinResult(result);

      handleBetResults(result);
      setIsSpinning(false);
    }, 9000);
  };

  const handleBetResults = async (result) => {
    let winnings = 0;
    let profitOrLoss = -currentBet;

    bet.forEach(b => {
      if (b.type === 'inside_whole' && b.numbers === result.number) {
        winnings += b.amt * (b.odds + 1);
      } else if (b.type === 'color' && b.numbers === result.color) {
        winnings += b.amt * (b.odds + 1);
      }
    });

    profitOrLoss += winnings;

    if (winnings > 0) {
      await withdrawMoney(winnings);
      const profitOrLossText = profitOrLoss !== 0 ? (profitOrLoss > 0 ? `(+💴${profitOrLoss})` : `(-💴${Math.abs(profitOrLoss)})`) : '';
      setWinningMessage(`You won 💴${winnings}! <small>${profitOrLossText}</small>`);
    } else {
      setWinningMessage(`You lost 💴${Math.abs(profitOrLoss)}`);
    }

    await refreshUser();
    setCurrentBet(0);
    setBet([]);
  };

  const setBetHandler = (num, objType, odds) => {
    if (isSpinning) {
      return;
    }
    const adjustedWager = user.money < wager ? user.money : wager;
    if (adjustedWager > 0) {
      setCurrentBet(currentBet + adjustedWager);
      const existingBetIndex = bet.findIndex(b => b.numbers === num && b.type === objType);
      if (existingBetIndex !== -1) {
        const updatedBet = [...bet];
        updatedBet[existingBetIndex].amt += adjustedWager;
        setBet(updatedBet);
      } else {
        const newBet = { amt: adjustedWager, type: objType, odds, numbers: num };
        setBet([...bet, newBet]);
      }
      setIsSpinning(false);
    }
  };

  return (
    <div className="page">
      <div className="page-container">
        <div className="casino-header">
          <div className="back-button-container">
            <FaArrowLeft className="back-button" onClick={() => navigate(-1)} />
          </div>
          <h3 className="game-header">Roulette</h3>
        </div>
        <div className="roulette-game">
          <div className="bankContainer">
            <div className="bank">
              <span>Balance:</span> <span>💴{user && typeof user.money === 'number' ? formatMoney(user.money) : '0'}</span>
            </div>
            <div className="bet">
              <span>Bet:</span> <span>💴{currentBet}</span>
            </div>
          </div>
          <div className="plate" id="plate">
            <div className={`wheel-container ${isSpinning ? 'spinning' : ''}`}>
              <ul className="inner">
                {Array.from({ length: 37 }, (_, i) => (
                  <li className={`number ${i === 0 ? 'greenNum' : numRed.includes(i) ? 'redNum' : 'blackNum'}`} key={i} style={{ '--i': i }}>
                    <span className="pit">{i}</span>
                  </li>
                ))}
              </ul>
              <div className="data">
                <div className="data-inner">
                  <div className="result">
                    {!isSpinning && spinResult && (
                      <>
                        <div className="result-number">{spinResult.number}</div>
                        <div className="result-color" style={{ backgroundColor: spinResult.color }}>{spinResult.color}</div>
                      </>
                    )}
                    {!isSpinning && !spinResult && (
                      <div className="mask">Place Your Bets</div>
                    )}
                    {isSpinning && (
                      <div className="mask">Spinning...</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="spin-btn-container">
            <button type="button" className="btn spin-btn" id="spin" onClick={spin} disabled={currentBet === 0 || isSpinning}>
              <span className="btn-label">{isSpinning ? 'Spinning...' : 'Spin'}</span>
            </button>
          </div>
          <div className="winning-message" dangerouslySetInnerHTML={{ __html: winningMessage || '&nbsp;' }} />
          <div id="betting_board">
            <div className="number_board">
              {Array.from({ length: 37 }, (_, i) => (
                <div
                  key={i}
                  className={`number_block ${i === 0 ? 'greenNum' : numRed.includes(i) ? 'redNum' : 'blackNum'}`}
                  onClick={() => setBetHandler(i, 'inside_whole', 35)}
                >
                  <div className="nbn">{i}</div>
                  {bet
                    .filter(b => b.numbers === i && b.type === 'inside_whole')
                    .map((b, index) => (
                      <div key={index} className="bet-indicator">{b.amt}</div>
                    ))}
                </div>
              ))}
            </div>
            <div className="betting-controls-wrapper">
              <div className="color-bet-buttons">
                <button className="rect-button red-button" onClick={() => setBetHandler('red', 'color', 1)} disabled={isSpinning}>
                  RED
                  {bet
                    .filter(b => b.numbers === 'red' && b.type === 'color')
                    .map((b, index) => (
                      <div key={index} className="bet-indicator">{b.amt}</div>
                    ))}
                </button>
                <button className="rect-button black-button" onClick={() => setBetHandler('black', 'color', 1)} disabled={isSpinning}>
                  BLACK
                  {bet
                    .filter(b => b.numbers === 'black' && b.type === 'color')
                    .map((b, index) => (
                      <div key={index} className="bet-indicator">{b.amt}</div>
                    ))}
                </button>
              </div>
            </div>
            <div className="bet-buttons">
              {ROULETTE_DENOMINATIONS.map((value, i) => (
                <div
                  key={i}
                  className={`chip chip-${value} ${wager === value ? 'cdChipActive' : ''}`}
                  onClick={() => setWager(value)}
                >
                  <span>{value}</span>
                </div>
              ))}
              <div className="chip clearBet" onClick={resetGame}>
                <span>Clear</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DelayRender(Roulette, 200);
